import { useState } from 'react';
import { IconButton } from '@mui/material';
import { useDispatch } from 'react-redux';

import { DeleteDialog } from '@app/components/dialog';
import { emptyCallback, useAuthRole } from '@app/utils';
import { useDialog, useRequestState } from '@app/hooks';
import {
  Iconify,
  MenuPopover,
  RowActions as MenuRowActions,
  useMenuPopover,
} from '@app/components';
import { Strings } from '@app/constants';
import { ILeave } from '../types';
import { AddLeave } from './add-leave-form';
import { sendToManager } from '../slice';
import { selectSendToManager } from '../selectors';
import { SendMail } from './send-mail';

interface Props {
  row: ILeave;
  itSelf: boolean;
}

const RowActions = ({ row, itSelf }: Props) => {
  const menuPopover = useMenuPopover();
  const deleteDialog = useDialog();
  const leaveDialog = useDialog();
  const sendToManagerDialog = useDialog();

  const { loading } = useRequestState({
    stateSelector: selectSendToManager,
    onSuccess: sendToManagerDialog.hide,
    successMessageShown: true,
    errorShown: true,
  });
  const { isSuperAdmin } = useAuthRole();
  const dispatch = useDispatch();
  const sendManager = () => {
    dispatch(sendToManager({ id: row?.id, req: 'Pending' }));
  };

  const [showSendMail, setShowSendMail] = useState(false);
  const handleSendMail = () => {
    setShowSendMail(true);
  };

  let actions = [];

  if (row.update === 'Draft') {
    actions = [
      { label: Strings.button.sendToManager, callback: sendToManagerDialog.show },
      { label: Strings.rowActions.edit, callback: leaveDialog.show },
    ];
  } else if (!isSuperAdmin && itSelf && row.update === Strings.status.approved) {
    actions = [{ label: Strings.rowActions.sendMail, callback: handleSendMail }];
  } else {
    actions = [{ label: Strings.rowActions.edit, callback: leaveDialog.show }];
  }

  return (
    <>
      <IconButton
        onClick={menuPopover.show}
        disabled={row.update === Strings.status.declined || row.update === Strings.status.pending}
      >
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>
      <MenuPopover
        open={menuPopover.rowMenuAnchorElement}
        arrow="right-top"
        sx={{ width: 180 }}
        onClose={menuPopover.hide}
      >
        <MenuRowActions actions={actions} onClickAction={menuPopover.hide} />
      </MenuPopover>
      <DeleteDialog
        title={`${Strings.common.delete} ${Strings.field.leave}`}
        deleteButtonTitle={Strings.button.confirm}
        caption={Strings.common.deleteCaption(Strings.field.leave)}
        loading={false}
        visible={deleteDialog.visible}
        onClickDelete={emptyCallback}
        onClose={deleteDialog.hide}
      />
      <DeleteDialog
        title={Strings.button.sendToManager}
        deleteButtonTitle={Strings.button.confirm}
        caption={Strings.leave.sendToManagerCaption}
        loading={loading}
        visible={sendToManagerDialog.visible}
        onClickDelete={sendManager}
        onClose={sendToManagerDialog.hide}
      />
      {showSendMail && <SendMail row={row} setShowSendMail={setShowSendMail} />}
      <AddLeave open={leaveDialog.visible} onClose={leaveDialog.hide} row={row} />
    </>
  );
};

export { RowActions };
